import React from "react";

export default function SQLServer_PI() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_PI</h1>
      <p>This is the SQLServer_PI component generated from the SQL JSON.</p>
    </div>
  );
}
